import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { PlatformTopBanner } from '../../components';

import css from './MaintenanceBanner.module.css';

// Edit these two constants and MAINTENANCE_DESCRIPTION to configure a maintenance window.
// The banner renders automatically when now is within [MAINTENANCE_START, MAINTENANCE_END).
// No deploy is needed to hide it — it self-hides after MAINTENANCE_END passes.
const MAINTENANCE_START = new Date('2026-04-27T11:00:00Z'); // 2 days before downtime (27 Apr 12:00 BST)
const MAINTENANCE_END = new Date('2026-04-29T12:00:00Z');   // end of downtime (29 Apr 13:00 BST)
const MAINTENANCE_DESCRIPTION = (
  <>
    <strong>Scheduled maintenance: Tuesday 29 April, 12:00–13:00 BST.</strong> Expect a brief
    period of downtime. Questions?{' '}
    <a className={css.link} href="mailto:support@classhoppa.com">
      support@classhoppa.com
    </a>
  </>
);

// Keyed to the start date so a new maintenance window always shows fresh.
const DISMISSED_KEY = `maintenanceBannerDismissed_${MAINTENANCE_START.toISOString()}`;

const MaintenanceBanner = ({ rootClassName, className }) => {
  const now = new Date();
  const isWithinWindow = now >= MAINTENANCE_START && now < MAINTENANCE_END;

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isWithinWindow) return;
    const dismissed = localStorage.getItem(DISMISSED_KEY);
    if (!dismissed) setVisible(true);
  }, [isWithinWindow]);

  if (!isWithinWindow || !visible) return null;

  const handleDismissed = () => {
    localStorage.setItem(DISMISSED_KEY, Date.now().toString());
    setVisible(false);
  };

  return (
    <PlatformTopBanner rootClassName={rootClassName} className={className} onDismiss={handleDismissed}>
      {MAINTENANCE_DESCRIPTION}
    </PlatformTopBanner>
  );
};

MaintenanceBanner.defaultProps = {
  rootClassName: null,
  className: null,
};

MaintenanceBanner.propTypes = {
  rootClassName: PropTypes.string,
  className: PropTypes.string,
};

export default MaintenanceBanner;
